import DeleteUserButton from './DeleteUserButton'

export default DeleteUserButton
